const i = Object.prototype.hasOwnProperty;
function c(t, e) {
  if (t === e)
    return !0;
  if (t && e && t.constructor === e.constructor) {
    if (t instanceof Date && e instanceof Date)
      return t.getTime() === e.getTime();
    if (t instanceof RegExp && e instanceof RegExp)
      return t.toString() === e.toString();
    if (Array.isArray(t) && Array.isArray(e)) {
      if (t.length === e.length) {
        for (let n = 0; n < t.length; n++)
          if (!c(t[n], e[n]))
            return !1;
        return !0;
      }
      return !1;
    }
    if (!t.constructor || typeof t == "object" && typeof e == "object") {
      let n = 0;
      for (const r in t)
        if (i.call(t, r) && ++n && !i.call(e, r) || !(r in e) || !c(t[r], e[r]))
          return !1;
      return Object.keys(e).length === n;
    }
  }
  return t !== t && e !== e;
}
export {
  c as isEqual
};
